import { TabMapping } from "../../../features/searchpage/constants/filters.constants"

export const HOMEPAGE_API_CONSTANTS = {
 GET_PRACTICE_POPUPAR_TOPICS:'getPracticePopularTopics',
 CASE_LAWS:"getRecentCaseLaws",
 CIRCULARS_NOTIFICATION :"getRecentCirNot",
 LEARNING_POPULAR_VIDEOS:"getLearningPopularVideos",
 VERIFY_OTP: "auth/registration/verifyOTP",
 REGISTER_FOR_FREE_TRAIL_LOGGED_IN_USER: "premium/postFreeTrialPremium",
 REGISTER_FOR_FREE_TRAIL_LOGGED_OUT_USER: "premium/postFreeTrialPremium",
 SEND_EMAIL_OTP: "auth/registration/generateEmailOTP",
 SEND_MOBILE_OTP: "auth/registration/generateOTP",
 REGISTER_USER_BY_PPC: "taxPractice/registerUserByPPC",
 GET_FREE_TRAIL_USER_DETAIL: "/userDetail",
 RESEARCH_TOPICS:'/getRecentResearch',
 GET_STATE_BY_PINCODE:"userAccount/getStateByPINCode",
SEND_OTP_CONSENT: "auth/registration/optinconsent",
}

export const OfferCategoryId = {
    ALL: "",
    GST: "111050000000016981",
 INCOME_TAX: "111050000000000002"
}
   
export const HomePageCarouselType = {
 RESEARCH:"research",
 PRACTICE: "practice",
 VIDEO: "video"
}

export const HomePageCarouselFilter = {
    ALL: "all",
    GST: "gst",
    INCOME_TAX: "incomeTax"
}

export const viewAllUrlPaths = {
    CASE_LAWS:{
        ALL: '/research/all/archives',
        INCOME_TAX: '/research/direct-tax-laws/archives',
        GST: '/research/gst-new/archives'
    },
    CIRNOT: {
        ALL: '/research/all/archives?moduleType=cirnot',
        INCOME_TAX: '/research/direct-tax-laws/archives?moduleType=cirnot',
        GST: '/research/gst-new/archives?moduleType=cirnot'
    },
    PRACTICE: {
        ALL: '/practice/all-feed?sortBy=popularity',
        INCOME_TAX: '/practice/all-feed?moduleType=Income-tax&sortBy=popularity',
        GST: '/practice/all-feed?moduleType=GST&sortBy=popularity'
    }
}

export const IMAGE_ICONS :any= {
    DEFAULT:`https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_1.png`,
    NAME: `https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_2.png`
    ,
    EMAIL: 
        `https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_3.png
`
    ,
    ORGANISATION: 
        `https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_4.png`
    ,
    PHONE: 
        `https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_5.png`
    ,
    PINCODE: 
         `https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_6.png`
    ,
    SUCCESS: 
       `https://cdn.taxmann.com/taxmann-images/taxmann-premium/free_trail_icons_7.png`
  }

export const CURRENCIES = [
  {
    value: "INR",
    label: "Indian Rupee (₹) - INR",
    icon: 
      `<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7621_15652)">
<path d="M23.9814 0.0185547V5.98145H0.0185547V0.0185547H23.9814Z" fill="#FF9933" stroke="#969BAC" stroke-width="0.0375"/>
<path d="M0 6H24V12H0V6Z" fill="white"/>
<path d="M0 12H24V18H0V12Z" fill="#128807"/>
<path d="M11.9999 11.4006C13.3254 11.4006 14.3999 10.3261 14.3999 9.00059C14.3999 7.6751 13.3254 6.60059 11.9999 6.60059C10.6744 6.60059 9.59991 7.6751 9.59991 9.00059C9.59991 10.3261 10.6744 11.4006 11.9999 11.4006Z" fill="#000088"/>
<path d="M11.9999 11.1004C13.1597 11.1004 14.0999 10.1602 14.0999 9.00039C14.0999 7.84059 13.1597 6.90039 11.9999 6.90039C10.8401 6.90039 9.8999 7.84059 9.8999 9.00039C9.8999 10.1602 10.8401 11.1004 11.9999 11.1004Z" fill="white"/>
<path d="M11.9998 9.42008C12.2318 9.42008 12.4198 9.23204 12.4198 9.00008C12.4198 8.76812 12.2318 8.58008 11.9998 8.58008C11.7679 8.58008 11.5798 8.76812 11.5798 9.00008C11.5798 9.23204 11.7679 9.42008 11.9998 9.42008Z" fill="#000088"/>
<path d="M14.0677 9.38255C14.1268 9.39033 14.181 9.3487 14.1888 9.28957C14.1966 9.23043 14.155 9.17618 14.0958 9.16839C14.0367 9.16061 13.9825 9.20224 13.9747 9.26137C13.9669 9.32051 14.0085 9.37476 14.0677 9.38255Z" fill="#000088"/>
<path d="M11.9997 11.1002L12.0717 9.84023L11.9997 9.24023L11.9277 9.84023L11.9997 11.1002Z" fill="#000088"/>
<path d="M13.8984 9.90495C13.9535 9.92778 14.0167 9.90161 14.0395 9.8465C14.0623 9.79139 14.0362 9.72822 13.9811 9.70539C13.926 9.68257 13.8628 9.70874 13.84 9.76384C13.8171 9.81895 13.8433 9.88212 13.8984 9.90495Z" fill="#000088"/>
<path d="M11.4563 11.0291L11.852 9.83069L11.9377 9.2325L11.7129 9.79342L11.4563 11.0291Z" fill="#000088"/>
<path d="M13.5996 10.365C13.647 10.4014 13.7148 10.3924 13.7511 10.3451C13.7874 10.2978 13.7784 10.23 13.7311 10.1937C13.6838 10.1574 13.616 10.1663 13.5797 10.2136C13.5434 10.2609 13.5523 10.3287 13.5996 10.365Z" fill="#000088"/>
<path d="M10.9498 10.8197L11.6422 9.76447L11.8798 9.20885L11.5174 9.69247L10.9498 10.8197Z" fill="#000088"/>
<path d="M13.1919 10.7328C13.2282 10.7801 13.296 10.789 13.3433 10.7527C13.3906 10.7164 13.3995 10.6486 13.3632 10.6013C13.3269 10.554 13.2591 10.5451 13.2118 10.5814C13.1645 10.6177 13.1556 10.6855 13.1919 10.7328Z" fill="#000088"/>
<path d="M10.5148 10.4853L11.4567 9.64523L11.83 9.17005L11.3548 9.5434L10.5148 10.4853Z" fill="#000088"/>
<path d="M12.7029 10.9813C12.7257 11.0364 12.7889 11.0625 12.844 11.0397C12.8991 11.0169 12.9253 10.9537 12.9025 10.8986C12.8796 10.8435 12.8165 10.8173 12.7614 10.8402C12.7063 10.863 12.6801 10.9262 12.7029 10.9813Z" fill="#000088"/>
<path d="M10.1811 10.049L11.3083 9.48135L11.7919 9.11899L11.2363 9.35664L10.1811 10.049Z" fill="#000088"/>
<path d="M12.166 11.0962C12.1738 11.1553 12.2281 11.197 12.2872 11.1892C12.3463 11.1814 12.388 11.1272 12.3802 11.068C12.3724 11.0089 12.3181 10.9672 12.259 10.975C12.1999 10.9828 12.1582 11.0371 12.166 11.0962Z" fill="#000088"/>
<path d="M9.97134 9.54314L11.207 9.28657L11.768 9.06173L11.1698 9.14748L9.97134 9.54314Z" fill="#000088"/>
<path d="M11.6179 11.0681C11.6101 11.1273 11.6517 11.1815 11.7109 11.1893C11.77 11.1971 11.8242 11.1555 11.832 11.0963C11.8398 11.0372 11.7982 10.9829 11.7391 10.9752C11.6799 10.9674 11.6257 11.009 11.6179 11.0681Z" fill="#000088"/>
<path d="M9.89983 9.00071L11.1598 9.07271L11.7598 9.00071L11.1598 8.92871L9.89983 9.00071Z" fill="#000088"/>
<path d="M11.0957 10.8999C11.0729 10.955 11.0991 11.0182 11.1542 11.041C11.2093 11.0639 11.2725 11.0377 11.2953 10.9826C11.3181 10.9275 11.2919 10.8643 11.2368 10.8415C11.1817 10.8187 11.1185 10.8448 11.0957 10.8999Z" fill="#000088"/>
<path d="M9.97143 8.45728L11.1699 8.85294L11.768 8.93869L11.2071 8.71385L9.97143 8.45728Z" fill="#000088"/>
<path d="M10.635 10.5997C10.5987 10.647 10.6076 10.7148 10.655 10.7511C10.7023 10.7874 10.7701 10.7785 10.8064 10.7312C10.8427 10.6839 10.8338 10.6161 10.7864 10.5798C10.7391 10.5435 10.6713 10.5524 10.635 10.5997Z" fill="#000088"/>
<path d="M10.1811 7.95071L11.2363 8.64307L11.7919 8.88071L11.3083 8.51836L10.1811 7.95071Z" fill="#000088"/>
<path d="M10.2674 10.1922C10.2201 10.2285 10.2111 10.2963 10.2474 10.3437C10.2838 10.391 10.3516 10.3999 10.3989 10.3636C10.4462 10.3273 10.4551 10.2595 10.4188 10.2122C10.3825 10.1648 10.3147 10.1559 10.2674 10.1922Z" fill="#000088"/>
<path d="M10.5148 7.51499L11.3548 8.45686L11.83 8.83021L11.4567 8.35503L10.5148 7.51499Z" fill="#000088"/>
<path d="M10.0179 9.7031C9.96277 9.72593 9.9366 9.7891 9.95943 9.84421C9.98226 9.89932 10.0454 9.92548 10.1005 9.90266C10.1556 9.87983 10.1818 9.81666 10.159 9.76155C10.1362 9.70644 10.073 9.68027 10.0179 9.7031Z" fill="#000088"/>
<path d="M10.9498 7.18105L11.5174 8.30824L11.8798 8.79186L11.6421 8.23624L10.9498 7.18105Z" fill="#000088"/>
<path d="M9.90355 9.16616C9.84441 9.17394 9.80278 9.22819 9.81057 9.28733C9.81835 9.34647 9.87261 9.38809 9.93174 9.38031C9.99088 9.37252 10.0325 9.31827 10.0247 9.25913C10.0169 9.2 9.96269 9.15837 9.90355 9.16616Z" fill="#000088"/>
<path d="M11.4563 6.97104L11.7129 8.20674L11.9377 8.76766L11.852 8.16947L11.4563 6.97104Z" fill="#000088"/>
<path d="M9.93186 8.61843C9.87272 8.61065 9.81847 8.65227 9.81069 8.71141C9.8029 8.77055 9.84453 8.8248 9.90367 8.83258C9.9628 8.84037 10.0171 8.79874 10.0248 8.7396C10.0326 8.68047 9.991 8.62622 9.93186 8.61843Z" fill="#000088"/>
<path d="M11.9998 6.90074L11.9278 8.16074L11.9998 8.76074L12.0718 8.16074L11.9998 6.90074Z" fill="#000088"/>
<path d="M10.1012 8.09603C10.0461 8.0732 9.98288 8.09937 9.96006 8.15448C9.93723 8.20958 9.9634 8.27276 10.0185 8.29558C10.0736 8.31841 10.1368 8.29224 10.1596 8.23714C10.1824 8.18203 10.1563 8.11885 10.1012 8.09603Z" fill="#000088"/>
<path d="M12.5433 6.97185L12.1477 8.17028L12.0619 8.76847L12.2868 8.20755L12.5433 6.97185Z" fill="#000088"/>
<path d="M10.3999 7.63594C10.3526 7.59963 10.2848 7.60855 10.2484 7.65587C10.2121 7.70319 10.2211 7.77099 10.2684 7.8073C10.3157 7.84361 10.3835 7.83469 10.4198 7.78736C10.4561 7.74004 10.4472 7.67225 10.3999 7.63594Z" fill="#000088"/>
<path d="M13.0498 7.18132L12.3574 8.23651L12.1198 8.79212L12.4821 8.30851L13.0498 7.18132Z" fill="#000088"/>
<path d="M10.8077 7.26818C10.7714 7.22086 10.7036 7.21193 10.6563 7.24824C10.609 7.28455 10.6 7.35235 10.6363 7.39967C10.6727 7.44699 10.7404 7.45592 10.7878 7.41961C10.8351 7.38329 10.844 7.3155 10.8077 7.26818Z" fill="#000088"/>
<path d="M13.4848 7.51571L12.5429 8.35575L12.1695 8.83092L12.6447 8.45757L13.4848 7.51571Z" fill="#000088"/>
<path d="M11.2967 7.01678C11.2738 6.96167 11.2107 6.93551 11.1555 6.95833C11.1004 6.98116 11.0743 7.04433 11.0971 7.09944C11.1199 7.15455 11.1831 7.18071 11.2382 7.15789C11.2933 7.13506 11.3195 7.07189 11.2967 7.01678Z" fill="#000088"/>
<path d="M13.8185 7.94905L12.6913 8.5167L12.2077 8.87905L12.7633 8.64141L13.8185 7.94905Z" fill="#000088"/>
<path d="M11.8335 6.90282C11.8258 6.84368 11.7715 6.80205 11.7124 6.80984C11.6532 6.81762 11.6116 6.87187 11.6194 6.93101C11.6272 6.99015 11.6814 7.03177 11.7406 7.02399C11.7997 7.0162 11.8413 6.96195 11.8335 6.90282Z" fill="#000088"/>
<path d="M14.0282 8.45491L12.7925 8.71147L12.2316 8.93631L12.8298 8.85057L14.0282 8.45491Z" fill="#000088"/>
<path d="M12.3818 6.93186C12.3895 6.87272 12.3479 6.81847 12.2888 6.81069C12.2296 6.8029 12.1754 6.84453 12.1676 6.90367C12.1598 6.9628 12.2014 7.01705 12.2606 7.02484C12.3197 7.03262 12.374 6.991 12.3818 6.93186Z" fill="#000088"/>
<path d="M14.0998 8.99929L12.8398 8.92729L12.2398 8.99929L12.8398 9.07129L14.0998 8.99929Z" fill="#000088"/>
<path d="M12.904 7.10007C12.9268 7.04496 12.9006 6.98179 12.8455 6.95896C12.7904 6.93613 12.7272 6.9623 12.7044 7.01741C12.6816 7.07251 12.7078 7.13569 12.7629 7.15852C12.818 7.18134 12.8811 7.15517 12.904 7.10007Z" fill="#000088"/>
<path d="M14.0283 9.54272L12.8298 9.14706L12.2316 9.06131L12.7926 9.28615L14.0283 9.54272Z" fill="#000088"/>
<path d="M13.3646 7.4003C13.4009 7.35298 13.392 7.28518 13.3447 7.24887C13.2974 7.21256 13.2296 7.22149 13.1932 7.26881C13.1569 7.31613 13.1659 7.38393 13.2132 7.42024C13.2605 7.45655 13.3283 7.44762 13.3646 7.4003Z" fill="#000088"/>
<path d="M13.8185 10.0493L12.7633 9.35693L12.2077 9.11929L12.6913 9.48164L13.8185 10.0493Z" fill="#000088"/>
<path d="M13.7322 7.80777C13.7795 7.77146 13.7884 7.70366 13.7521 7.65634C13.7158 7.60902 13.648 7.60009 13.6007 7.6364C13.5534 7.67271 13.5445 7.74051 13.5808 7.78783C13.6171 7.83515 13.6849 7.84408 13.7322 7.80777Z" fill="#000088"/>
<path d="M13.4848 10.485L12.6447 9.54314L12.1696 9.16979L12.5429 9.64497L13.4848 10.485Z" fill="#000088"/>
<path d="M13.9818 8.2969C14.0369 8.27407 14.0631 8.2109 14.0403 8.15579C14.0174 8.10068 13.9543 8.07452 13.8992 8.09734C13.8441 8.12017 13.8179 8.18334 13.8407 8.23845C13.8635 8.29356 13.9267 8.31973 13.9818 8.2969Z" fill="#000088"/>
<path d="M13.0499 10.8189L12.4823 9.69176L12.1199 9.20814L12.3576 9.76376L13.0499 10.8189Z" fill="#000088"/>
<path d="M14.0962 8.83384C14.1553 8.82606 14.197 8.77181 14.1892 8.71267C14.1814 8.65353 14.1272 8.61191 14.068 8.61969C14.0089 8.62748 13.9672 8.68173 13.975 8.74087C13.9828 8.8 14.0371 8.84163 14.0962 8.83384Z" fill="#000088"/>
<path d="M12.5434 11.029L12.2869 9.79326L12.062 9.23234L12.1478 9.83053L12.5434 11.029Z" fill="#000088"/>
</g>
<defs>
<clipPath id="clip0_7621_15652">
<rect width="24" height="18" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
`
  },
  {
    value: "USD",
    label: "United States Dollar ($) - USD",
    icon: 
     ` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7621_15755)">
<mask id="path-3-inside-1_7621_15755" fill="white">
<path d="M0 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H0"/>
</mask>
<path d="M0 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H0" fill="#BD3D44"/>
<path d="M0 3V3.0375H21V3V2.9625H0V3ZM24 6H23.9625V18H24H24.0375V6H24ZM21 21V20.9625H0V21V21.0375H21V21ZM24 18H23.9625C23.9625 19.6361 22.6361 20.9625 21 20.9625V21V21.0375C22.6776 21.0375 24.0375 19.6776 24.0375 18H24ZM21 3V3.0375C22.6361 3.0375 23.9625 4.36386 23.9625 6H24H24.0375C24.0375 4.32244 22.6776 2.9625 21 2.9625V3Z" fill="#969BAC" mask="url(#path-3-inside-1_7621_15755)"/>
<path d="M0 5.07422H24H0ZM0 7.83797H24H0ZM0 10.613H24H0ZM0 13.388H24H0ZM0 16.163H24H0ZM0 18.938H24H0Z" fill="black"/>
<path d="M0 5.07422H24M0 7.83797H24M0 10.613H24M0 13.388H24M0 16.163H24M0 18.938H24" stroke="white" stroke-width="1.3875"/>
<path d="M0 3H13.68V12.6938H0" fill="#192F5D"/>
</g>
<defs>
<clipPath id="clip0_7621_15755">
<rect y="3" width="24" height="18" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
`
    
  },
];
